'use strict';

angular.module('amexReconciliationApp')
  .component('approveAllUnapprovedTransactions', {
    templateUrl: 'scripts/views/components/approve-all-unapproved-transactions.html',
    controller: function (TransactionTabFilterModel,
                          TransactionsModel,
                          TransactionSearchModel,
                          TransactionService,
                          ApproveAllTransactionsRepository,
                          SiteConfigModel) {

      var self = this;
      self.toggle = false;
      self.processing = false;

      self.showApproveAll = function () {
        return (
            TransactionTabFilterModel.isTabActive('needs-bca-manager-approval') ||
            TransactionTabFilterModel.isTabActive('needs-card-manager-approval') ||
            TransactionTabFilterModel.isTabActive('needs-accounting-manager-approval')
          ) && SiteConfigModel.cycleLevelApprovalOn();
      };

      self.allTransactionsApproved = function() {
        var approvalType;

        if (TransactionSearchModel.isBcaManager()) {
          approvalType = 'bcaManagerApproved';
        } else if (TransactionSearchModel.isCardManager()) {
          approvalType = 'cardManagerApproved';
        } else if (TransactionSearchModel.isAccountingManager()) {
          approvalType = 'accountingManagerApproved';
        } else {
          return true;
        }

        var unapprovedTransaction = _.find(TransactionsModel.transactions(), function(transaction) {
          return transaction.mutableTransactionProperties[approvalType] === false;
        });

        return (unapprovedTransaction === undefined);
      };

      self.approveAll = function () {
        TransactionsModel.loading(true);
        self.processing = true;
        self.togglePopover();
        ApproveAllTransactionsRepository.approveAllTransactions()
          .then(function (updatedTransactions) {
            updateTransactions(updatedTransactions.data);
          })
          .finally(function () {
            TransactionsModel.loading(false);
            self.processing = false;
          });
      };

      self.togglePopover = function () {
        self.toggle = !self.toggle;
      };

      function updateTransactions(updatedTransactions) {
        var oldTransactions = TransactionsModel.transactions();
        if(updatedTransactions.length > 0) {
          TransactionsModel.transactions(_.uniqBy(updatedTransactions.concat(oldTransactions), 'id'));
        }
      }
    }
  });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/components/approveAllUnapprovedTransactions.js
// module id = 436
// module chunks = 0